import { render, staticRenderFns } from "./quanFuPrint.vue?vue&type=template&id=5435cdb2&scoped=true"
import script from "./quanFuPrint.vue?vue&type=script&lang=js"
export * from "./quanFuPrint.vue?vue&type=script&lang=js"
import style0 from "./quanFuPrint.vue?vue&type=style&index=0&id=5435cdb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5435cdb2",
  null
  
)

export default component.exports